import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Solutions from './components/Solutions';
import IndustryFocus from './components/IndustryFocus';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import CaseStudy from './components/CaseStudy';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import HeroNew from './components/HeroNew';

export default function Home() {
  const sharedJourneyRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: sharedJourneyRef,
    offset: ['start end', 'end start'],
  });
  const blueOverlayOpacity = useTransform(scrollYProgress, [0, 0.08, 0.17, 0.3], [0, 0.28, 0.82, 1]);
  const orangeOverlayOpacity = useTransform(scrollYProgress, [0, 0.38, 0.6, 0.84], [0, 0, 0.56, 1]);

  return (
    <div className="min-h-screen bg-brand-beige-light">
      <Navbar />
      <HeroNew />
      <Features />
      <div ref={sharedJourneyRef} className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute inset-0 bg-[#0D0D0D]" />
          <div className="absolute left-[6%] top-[8%] h-64 w-64 rounded-full bg-brand-green/10 blur-3xl" />
          <div className="absolute right-[-8%] top-[12%] h-80 w-80 rounded-full bg-brand-ocean/10 blur-3xl" />
          <div className="absolute left-[34%] top-[22%] h-52 w-52 rounded-full bg-white/[0.05] blur-3xl" />
        </div>
        <motion.div className="pointer-events-none absolute inset-0" style={{ opacity: blueOverlayOpacity }}>
          <div className="absolute inset-0 bg-gradient-to-b from-[#dbeeff] via-[#eef7ff] to-[#d7ebff]" />
          <div className="absolute left-[8%] top-[6%] h-64 w-64 rounded-full bg-brand-green/10 blur-3xl" />
          <div className="absolute left-[-8%] top-12 h-72 w-72 rounded-full bg-[rgba(146,197,255,0.28)] blur-3xl" />
          <div className="absolute right-[-4%] top-[12%] h-80 w-80 rounded-full bg-[rgba(255,255,255,0.58)] blur-3xl" />
          <div className="absolute left-[26%] top-[20%] h-56 w-56 rounded-full bg-[rgba(195,225,255,0.36)] blur-3xl" />
        </motion.div>
        <motion.div className="pointer-events-none absolute inset-0" style={{ opacity: orangeOverlayOpacity }}>
          <div className="absolute inset-0 bg-gradient-to-b from-[#dbeeff] via-[#fff0e4] to-[#f7dfc8]" />
          <div className="absolute left-[10%] top-[42%] h-64 w-64 rounded-full bg-brand-green/10 blur-3xl" />
          <div className="absolute right-[-4%] top-[46%] h-72 w-72 rounded-full bg-[rgba(255,173,112,0.3)] blur-3xl" />
          <div className="absolute bottom-[-8%] left-[-5%] h-72 w-72 rounded-full bg-[rgba(247,189,140,0.32)] blur-3xl" />
          <div className="absolute right-[24%] top-[62%] h-52 w-52 rounded-full bg-[rgba(255,214,182,0.35)] blur-3xl" />
        </motion.div>
        <Solutions />
        <IndustryFocus />
        <Process />
      </div>
      <CaseStudy />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
